module.exports = __webpack_public_path__ + "img/slogon.e6c49033.webp";